// External imports
import { Dispatch, SetStateAction, useRef } from "react";

// Local imports
import classes from "./style.module.css";
import SelectMenu from "./SelectMenu";

// Component props for TextInput
interface Props {
  text: string;
  setText: Dispatch<SetStateAction<string>>;
}

export default function TextInput({ text, setText }: Props) {
  // Reference of input field
  const inputRef = useRef<HTMLTextAreaElement>(null);

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className={`${classes.inputBox}`}>
        <textarea
          ref={inputRef}
          className={`${classes.input}`}
          spellCheck={false}
          placeholder="Type here to preview the text below..."
          value={text}
          maxLength={450}
          onChange={(e) => setText(e.target.value)}
        ></textarea>

        <SelectMenu text={text} setText={setText} />

        <span className={`${classes.count}`}>
          {inputRef.current?.value.length}/450
        </span>
      </div>
    </form>
  );
}
